module.exports = __webpack_public_path__ + "static/lock-faa8b1f423a222e7db8322a1e5903c49.svg";